import React from 'react'
import { ACCOUNT } from '../../../common/enum/account'
import {
  ExpiredSessionModalContainer,
  ExpiredSessionModalCloseButton,
  ExpiredSessionModalHardRule,
  ExpiredSessionModalMessageTypography,
  ExpiredSessionModalTitleTypography
} from './styles'

export const ExpiredSessionModal = ({ setShowExpiredSessionModal }) => (
  <ExpiredSessionModalContainer>
    <ExpiredSessionModalCloseButton onClick={() => setShowExpiredSessionModal(false)} />
    <ExpiredSessionModalTitleTypography variant="h6">
      {ACCOUNT.SESSION_EXPIRED_MODAL_TITLE}
    </ExpiredSessionModalTitleTypography>
    <ExpiredSessionModalHardRule />
    <ExpiredSessionModalMessageTypography variant="body1">
      {ACCOUNT.SESSION_EXPIRED_MODAL_MESSAGE}
    </ExpiredSessionModalMessageTypography>
  </ExpiredSessionModalContainer>
)
